
import React from "react";
import styled from "styled-components";

import { View } from "core/decorators/View";
import { toTypographyCss, TypographyStylesConfig } from "../common/TypographyStylesConfig";
import FontAwesomeIconViewConfig from "./FontAwesomeIconConfig";
import { FontAwesomeIconStylesConfig, toBlockCss } from "../common/FontAwesomeIconStylesConfig";

interface IFontAwesomeIconProps {
	block: FontAwesomeIconStylesConfig;
	typography: TypographyStylesConfig;
}

const StyledBoxSection = styled.div<IFontAwesomeIconProps>(
	({block, typography}: IFontAwesomeIconProps) => [toBlockCss(block), toTypographyCss(typography)]
);

export enum FontAwesomeIcon {
	MINIMAL = "minimal",
	PANEL = "panel"
}

/**
 * @description view with header and body sections, not interactive
 */
@View({ id: "fontAwesomeIcon", configClass: FontAwesomeIconViewConfig, variants: FontAwesomeIcon })
export class FontAwesomeIconView extends React.PureComponent<any> {

	public render() {
		const { config } = this.props;
		
		return (!config.iconPosition || config.iconPosition === 'left')? (
					<React.Fragment>
						<StyledBoxSection
							block={config.bodyDefaultState}
							key="body"
							typography={config.bodyTypography}
							style={{borderTopRightRadius: 0, borderTopLeftRadius: 0, borderTopWidth: 0}}
						>
							{this.props.children[0]}
						</StyledBoxSection> 
						{this.props.children[1]}
					</React.Fragment>) : (
					<React.Fragment>
						{this.props.children[1]}
						<StyledBoxSection
							block={config.bodyDefaultState}
							key="body"
							typography={config.bodyTypography}
							style={{borderTopRightRadius: 0, borderTopLeftRadius: 0, borderTopWidth: 0}}
						>
							{this.props.children[0]}
						</StyledBoxSection> 
					</React.Fragment>
				)
	}
}



// WEBPACK FOOTER //
// ./src/common/views/fontAwesomeIcon/FontAwesomeIcon.view.tsx